module.exports = __webpack_public_path__ + "static/kyle.279f1de2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/kyle.jpg
// module id = 460
// module chunks = 114276838955818